// Premium enhancement for Horizon's built-in quantity selector.
// Adds ripple + glow on button press and a bump animation on the
// number itself, without touching Horizon's own increment/decrement logic.
(function () {
  function ripple(btn, evt) {
    var rect = btn.getBoundingClientRect();
    var x = (evt.clientX || rect.left + rect.width / 2) - rect.left;
    var y = (evt.clientY || rect.top + rect.height / 2) - rect.top;
    var span = document.createElement('span');
    span.className = 'qs-ripple';
    span.style.left = (x - 2) + 'px';
    span.style.top = (y - 2) + 'px';
    btn.appendChild(span);
    setTimeout(function () { span.remove(); }, 650);
  }

  function pulse(btn) {
    btn.classList.add('qs-pulse');
    setTimeout(function () { btn.classList.remove('qs-pulse'); }, 380);
  }

  function bump(input) {
    input.classList.remove('qs-bump');
    void input.offsetWidth; // restart animation
    input.classList.add('qs-bump');
  }

  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest('.quantity-minus, .quantity-plus');
    if (!btn) return;
    ripple(btn, evt);
    pulse(btn);

    var wrapper = btn.closest('.quantity-selector-wrapper');
    var input = wrapper && wrapper.querySelector('input[type="number"]');
    if (input) {
      setTimeout(function () { bump(input); }, 20);
    }
  });
})();
